import React from 'react';

const steps = [
  { label: 'Create', description: 'Start from a template or API call', icon: 'fa-plus-circle', color: 'bg-[#055EFD]' },
  { label: 'Connect', description: 'Link FAQ, calendar, payments, staff', icon: 'fa-plug', color: 'bg-purple-600' },
  { label: 'Test', description: 'Automated voice and text simulations', icon: 'fa-flask', color: 'bg-amber-500' },
  { label: 'Deploy', description: 'Go live with validated confidence', icon: 'fa-rocket', color: 'bg-green-600' },
  { label: 'Validate', description: 'Every call checked against quality gates', icon: 'fa-check-circle', color: 'bg-cyan-600' },
  { label: 'Detect', description: 'Failures triaged and root-caused automatically', icon: 'fa-search', color: 'bg-red-500' },
  { label: 'Resolve', description: 'Fix written, tested, and deployed autonomously', icon: 'fa-shield', color: 'bg-orange-500' },
];

const ImprovementLoop = () => {
  return (
    <div className="px-8 py-20 bg-[#f9f9fb]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold font-['Montserrat'] text-[#222324] mb-4">
            Production Issues Resolved in Minutes, Not Days
          </h2>
          <p className="text-gray-600 text-lg font-medium font-['Inter'] max-w-2xl mx-auto">
            Every call is validated. Failures are detected, root-caused, and resolved autonomously before they become patterns. No alert fatigue. No manual triage.
          </p>
        </div>

        {/* Loop visualization */}
        <div className="relative">
          {/* Desktop: horizontal flow with wrap */}
          <div className="flex flex-wrap justify-center gap-4">
            {steps.map((step, index) => (
              <div key={step.label} className="flex items-center">
                <div className="flex flex-col items-center text-center w-28">
                  <div className={`w-14 h-14 ${step.color} rounded-full flex items-center justify-center mb-3 shadow-lg`}>
                    <i className={`fa ${step.icon} text-white text-lg`}></i>
                  </div>
                  <span className="text-[#222324] text-sm font-bold font-['Montserrat']">{step.label}</span>
                  <span className="text-gray-500 text-[11px] font-['Inter'] mt-1 leading-tight">{step.description}</span>
                </div>
                {index < steps.length - 1 && (
                  <i className="fa fa-chevron-right text-gray-300 text-sm mx-1 hidden sm:block"></i>
                )}
              </div>
            ))}
            {/* Loop-back arrow */}
            <div className="flex items-center">
              <div className="flex flex-col items-center text-center w-28">
                <div className="w-14 h-14 bg-[#055EFD]/10 border-2 border-[#055EFD] border-dashed rounded-full flex items-center justify-center mb-3">
                  <i className="fa fa-repeat text-[#055EFD] text-lg"></i>
                </div>
                <span className="text-[#055EFD] text-sm font-bold font-['Montserrat']">Repeat</span>
                <span className="text-gray-500 text-[11px] font-['Inter'] mt-1 leading-tight">Continuous improvement</span>
              </div>
            </div>
          </div>
        </div>

        {/* Key message */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-white border border-gray-200 rounded-lg px-6 py-4">
            <i className="fa fa-shield text-[#055EFD] text-lg"></i>
            <p className="text-[#222324] text-sm font-medium font-['Inter']">
              The platform monitors, investigates, and fixes production issues autonomously. Your agent improves from every real conversation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImprovementLoop;
